export const initialVehicleCategoryForm = {
  name: "",
  description: "",
  noOfSeats: "",
};

export const normalizeVehicleCategories = (data) => {
  if (Array.isArray(data)) return data;
  return data?.vehicleCategories || data?.items || [];
};

export const filterVehicleCategories = (categories, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return categories;

  return categories.filter((category) => {
    const name = category?.name?.toLowerCase() || "";
    const description = category?.description?.toLowerCase() || "";
    const seats = String(category?.noOfSeats || "").toLowerCase();

    return name.includes(term) || description.includes(term) || seats.includes(term);
  });
};

export const mapVehicleCategoryToForm = (category) => ({
  name: category?.name || "",
  description: category?.description || "",
  noOfSeats:
    typeof category?.noOfSeats === "number"
      ? String(category.noOfSeats)
      : (category?.noOfSeats || ""),
});

export const validateVehicleCategoryForm = (form) => {
  const errors = {};

  if (!form.name.trim()) errors.name = "Name is required.";

  if (!form.noOfSeats || Number(form.noOfSeats) <= 0) {
    errors.noOfSeats = "Number of seats must be greater than 0.";
  }

  return errors;
};

export const buildVehicleCategoryPayload = (form) => ({
  name: form.name.trim(),
  description: form.description.trim(),
  noOfSeats: Number(form.noOfSeats),
});
